import React from 'react'
import Background from 'components/Background'

const PartnersViewBackground = () => (
  <Background height="40.5vh" />
)
export default PartnersViewBackground
